"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tersifyFunction = void 0;
var hasTersifyFn_js_1 = require("./hasTersifyFn.js");
var tersify_js_1 = require("./tersify.js");
var index_js_1 = require("./tersifyAcorn/index.js");
var tersifyFunctionByString_js_1 = require("./tersifyFunctionByString.js");
function tersifyFunction(context, fn, _length) {
    if (!context.raw && (0, hasTersifyFn_js_1.hasTersifyFn)(fn) && fn.tersify !== tersify_js_1.defaultTersify) {
        return fn.tersify({ maxLength: context.maxLength, raw: context.raw });
    }
    try {
        return (0, index_js_1.tersifyAcorn)(context, fn, context.maxLength);
    }
    catch (e) {
        // istanbul ignore next
        if (e.name !== 'SyntaxError')
            throw e;
        // istanbul ignore next
        return (0, tersifyFunctionByString_js_1.tersifyFunctionByString)(fn, context);
    }
}
exports.tersifyFunction = tersifyFunction;
//# sourceMappingURL=tersifyFunction.js.map